import { render } from "./index.vue?vue&type=template&id=3c13281d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c13281d&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c13281d"],['__file',"src/views/room/hotel/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c13281d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c13281d', __exports__)) {
    console.log('reload')
    api.reload('3c13281d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3c13281d&scoped=true", () => {
    console.log('re-render')
    api.rerender('3c13281d', render)
  })

}


export default __exports__